import PATH from "contants/path";

export const whiteListHeader = [PATH.home, PATH.lottery];
